// extracted by mini-css-extract-plugin
module.exports = {"option":"menu-option-coverage_option__QMj7g","optionHeader":"menu-option-coverage_optionHeader__l4eoA","optionHeaderLabel":"menu-option-coverage_optionHeaderLabel__1RfWY"};